const ShopAndProductQueryString = ({ids}: {ids: string[]}) => {
  const formattedIds = ids.map((item) => `"${item}"`);
  return `
  fragment ImageFragment on Image {
    id
    url
    altText
    width
    height
}
  query ShoppableProductsQuery {

    shop {
      name
      primaryDomain {
        url
      }
      paymentSettings {
        countryCode
      }
    }
    nodes(ids: [${formattedIds}]) {
      ... on Product {
        __typename
        availableForSale
        createdAt
        description
        descriptionHtml
        handle
        id
        onlineStoreUrl
        productType
        publishedAt
        tags
        title
        updatedAt
        vendor
        variants(first: 250) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              id
              title
              selectedOptions {
                name
                value
              }
              image {
                ...ImageFragment
              }
              availableForSale
              priceV2 {
                amount
                currencyCode
              }
            }
          }
        }
        images(first: 250) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              id
              transformedSrc(maxWidth: 350)
            }
          }
        }
      }
    }
  }
`;
};

export default ShopAndProductQueryString;
